import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/resort/Marquee";
import ResortsCatalog from "@/components/home/ResortsCatalog";
import HowItWorks from "@/components/home/HowItWorks";
import Proofs from "@/components/home/Proofs";
import ConciergeCTA from "@/components/agent/ConciergeCTA";
import QuoteForm from "@/components/QuoteForm";
import Faq from "@/components/Faq";
import { HOME_MARQUEE, PORTAL_FAQS } from "@/data/site";
import { RESORTS } from "@/data/resorts";
import { useSEO } from "@/lib/seo";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
    const location = useLocation();
    const [quoteResort, setQuoteResort] = useState("fazzenda-park-resort");

    useSEO({
        title: null,
        description:
            "Destino Resorts — curadoria independente dos melhores resorts do Brasil. Compare destinos e receba cotação personalizada direto no seu WhatsApp.",
        image: RESORTS[0]?.heroImage,
        path: "/",
    });

    useEffect(() => {
        const target = location.state?.scrollTo || location.hash?.replace("#", "");
        if (!target) return undefined;
        const t = setTimeout(() => scrollToId(target), 400);
        return () => clearTimeout(t);
    }, [location]);

    const handleQuote = (slug) => {
        setQuoteResort(slug);
        scrollToId("cotacao-rapida");
    };

    return (
        <>
            <Hero />
            <Marquee items={HOME_MARQUEE} />
            <ResortsCatalog onQuote={handleQuote} />
            <HowItWorks />
            <ConciergeCTA />
            <QuoteForm
                sectionId="cotacao-rapida"
                resort={quoteResort}
                onResortChange={setQuoteResort}
                eyebrow="Cotação Rápida"
                heading="Solicite sua cotação"
            />
            <Proofs />
            <Faq items={PORTAL_FAQS} title="Perguntas sobre o portal" />
        </>
    );
}
